






























import Vue from "vue";
import { Component } from "vue-property-decorator";
import axios from "axios";

interface CommandsDataEntryInterface {
  type: number;
  channel: string;
  name: string;
  text: string;
  hidden: number;
  enabled: any;
}

@Component({
  name: "channel-detail-commands"
})
export default class ChannelCommands extends Vue {
  isLoaded = false;
  commands: CommandsDataEntryInterface[] = [];

  get hasData() {
    return this.commands.length > 0;
  }

  mounted() {
    const channel = this.$route.params.channel;

    axios.get(`/api/c/${channel}/commands`).then(response => {
      this.commands = response.data;
      console.log(this.commands);
      this.isLoaded = true;
    });
  }
}
